// =========================
// MONEY FORMAT
// =========================
function formatMoney(cents) {
  return (cents / 100).toLocaleString(undefined, {
    style: 'currency',
    currency: Shopify.currency.active
  });
}


// =========================
// FREE SHIPPING BAR
// =========================
function updateFreeShippingBar(cartTotal, itemCount = 0) {
  const bar = document.querySelector('.free-shipping-bar');
  if (!bar) return;

  const threshold = parseInt(bar.dataset.threshold);
  const text = bar.querySelector('.free-shipping-text');
  const fill = bar.querySelector('.progress-bar-fill');

  // reset every time
  bar.classList.remove('is-hidden');
  fill.style.width = "0%";

  // empty cart
  if (itemCount === 0 || cartTotal === 0) {
    bar.classList.add('is-hidden');
    return;
  }

  let progress = (cartTotal / threshold) * 100;
  if (progress > 100) progress = 100;

  fill.style.width = progress + "%";

  if (cartTotal >= threshold) {
    text.innerHTML = "🎉 You got FREE shipping!";
  } else {
    let remaining = threshold - cartTotal;
    text.innerHTML = `You're ${formatMoney(remaining)} away from FREE shipping`;
  }
}


// =========================
// EVENT LISTENER (SINGLE SOURCE)
// =========================
document.addEventListener('cart:updated', function (event) {
  if (!event.detail || !event.detail.cart) return;

  setTimeout(() => {
    updateFreeShippingBar(
      event.detail.cart.total_price,
      event.detail.cart.item_count
    );
  }, 200);
});


// =========================
// INITIAL LOAD
// =========================
fetch('/cart.js')
  .then(res => res.json())
  .then(cart => {
    document.dispatchEvent(new CustomEvent('cart:updated', {
      detail: { cart }
    }));
  });


// =========================
// CART NOTE TOGGLE
// =========================
document.addEventListener('click', function(e) {
  const label = e.target.closest('.cart-note-toggle');
  if (!label) return;

  e.preventDefault();

  const content = label.closest('.cart-note-wrapper')
                       .querySelector('.cart-note-content');

  content.classList.toggle('active');
});


// =========================
// SLIDER CONTROLS
// =========================
document.addEventListener('click', function(e) {

  const prevBtn = e.target.closest('.reco-prev');
  const nextBtn = e.target.closest('.reco-next');

  if (!prevBtn && !nextBtn) return;

  e.preventDefault();
  e.stopPropagation();

  const slider = document.querySelector('.cart-recommendations-slider');
  if (!slider) return;

  const scrollAmount = slider.offsetWidth;

  if (nextBtn) {
    slider.scrollBy({ left: scrollAmount, behavior: 'smooth' });
  }

  if (prevBtn) {
    slider.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
  }

});


// =========================
// ADD TO CART (RECOMMENDATIONS)
// =========================
document.addEventListener('click', function(e) {
  const btn = e.target.closest('.reco-add-to-cart-btn');
  if (!btn) return;

  e.preventDefault();

  const variantId = btn.dataset.id;

  btn.disabled = true;
  btn.innerText = "Adding...";

  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: variantId, quantity: 1 })
  })
  .then(res => res.json())
  .then(() => {

    fetch('/cart.js')
      .then(res => res.json())
      .then(cartData => {

        btn.disabled = false;
        btn.innerText = "Add to Cart";

        // re-init drawer
        var cartDrawer = new theme.CartDrawer();
        cartDrawer.init();

        // trigger single event
        document.dispatchEvent(new CustomEvent('cart:updated', {
          detail: { cart: cartData }
        }));

      });

  })
  .catch(() => {
    btn.disabled = false;
    btn.innerText = "Add to Cart";
  });
});





function syncShippingBarFromCart() {
  fetch('/cart.js')
    .then(res => res.json())
    .then(cart => {

      const bar = document.querySelector('.free-shipping-bar');

      if (!bar) return;

      updateFreeShippingBar(
        cart.total_price,
        cart.item_count
      );

    });
}

document.addEventListener('click', function (e) {
  const btn = e.target.closest('.add-to-cart');
  if (!btn) return;

  // allow cart submit to proceed normally
  setTimeout(() => {
 syncShippingBarFromCart();
  }, 4000);

});


// =========================
// REMOVE ITEM
// =========================
document.addEventListener('click', function(e) {
  const btn = e.target.closest('.cart-remove-btn');
  if (!btn) return;

  e.preventDefault();

  const key = btn.dataset.key;

  fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: key, quantity: 0 })
  })
  .then(res => res.json())
  .then(cart => {

    var cartDrawer = new theme.CartDrawer();
    cartDrawer.init();

    document.dispatchEvent(new CustomEvent('cart:updated', {
      detail: { cart }
    }));

  });
});